<template id="countdown-template">
    <div class="text-center colorWhite">
        <div id="clockdiv" v-if="seconds>=0">
            <div v-if="days>0">
                <span class="hours">{{ convertToNepali(days) }}</span>
                <span class="smalltext"> {{text.days}}</span>
            </div>
            <div v-if="hours>0">
                <span class="hours">{{ convertToNepali(hours) }}</span>
                <span class="smalltext"> {{text.hour}}</span>
            </div>
            <div v-if="minutes>0">
                <span class="minutes">{{ convertToNepali(minutes) }}</span>
                <span class="smalltext"> {{text.minute}}</span>
            </div>
            <div v-if="seconds>=0">
                <span class="seconds">{{ convertToNepali(seconds) }}</span>
                <span class="smalltext"> {{text.second}}</span>
            </div>
        </div>
        <div class="text-center colorWhite timeStartEnd" v-else>{{text.votingEnded}}</div>
    </div>
</template>

<script>
    import usedText, {useNepali} from "../util/languageText";
    import {englishToNepali} from "../util/Common";

    export default {
        template: '#countdown-template',
        name: "CountDown",
        props : {
            date : {
                type: Number,
                coerce: str => Math.trunc(Date.parse(str) / 1000)
            }
        },

        data() {
            return {
                now: Math.trunc((new Date()).getTime() / 1000),
                text:usedText
            }
        },
        mounted() {
            window.setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000);
            },1000);
        },

        computed: {
            seconds() {
                return (this.date - this.now) % 60;
            },
            minutes() {
                return Math.trunc((this.date - this.now) / 60) % 60;
            },
            hours() {
                return Math.trunc((this.date - this.now) / 60 / 60) % 24;
            },
            days() {
                return Math.trunc((this.date - this.now) / 60 / 60 / 24);
            }
        },
        methods:{
            convertToNepali : function(englishNumber){
                if(useNepali)
                    return englishToNepali(englishNumber);
                else  return  englishNumber ;
            },
        }
    }
</script>

<style scoped>

</style>